module.exports = __webpack_public_path__ + "static/media/ic-filter-users.fd251594.svg";